import {
    Button,
    FormHelperText,
    IconButton,
    MenuItem,
    Modal,
    MuiThemeProvider,
    Paper,
    TextField,
    Typography,
    withStyles
} from '@material-ui/core';
import css from './AddTruck.module.css';
import cs from 'classnames';
import { format } from 'date-fns';
import Downshift from 'downshift';
import deburr from 'lodash/deburr';
import { DatePicker } from 'material-ui-pickers';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from 'components/TrustCenter/store/actions';
import { getLocalDateString } from 'components/Common/Utils/DateUtils';
import { DEFAULT_THEME } from 'theme/CommonTheme';
import * as Constants from 'constants/Constants';
import { isEmptyList, isNotBlank, isNotEmptyList } from 'components/Common/Utils/StringUtils';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';

const styles = (theme) => ({
    paper: {
        position: 'absolute',
        borderRadius: 5,
        width: '930px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '10px 20px',
        outline: 'none'
    },
    root: {
        flexGrow: 1
    },
    container: {
        flexGrow: 1,
        position: 'relative',
        width: '100%'
    },
    dropDownPaper: {
        position: 'fixed',
        zIndex: 15000,
        maxHeight: 200,
        overflowY: 'auto'
    },
    inputRoot: {
        flexWrap: 'wrap'
    },
    inputInput: {
        width: '100%',
        flexGrow: 1
    },
    divider: {
        height: 4
    },
    spacing: 2
});

function getModalStyle() {
    const top = 18;
    const left = 23;

    return {
        top: `${top}%`,
        left: `${left}%`
    };
}

const AddTruck = (props) => {
    const {
        classes,
        showAddTruckModel,
        showAddTruck,
        startDate,
        endDate,
        newTruckRequest,
        mobilityData,
        newTruckAgreementList,
        addNewTruck,
        newTruckAgreements,
        closeAddTruckModel,
        updateTruck,
        clearTruck,
        removeTruck,
        agreements
    } = props;

    const [modalStyle] = useState(getModalStyle);

    const [showSearchTruck, setShowSearchTruck] = useState(false);

    let selectedItem = '';

    const [truckInputEditList, setTruckInputEditList] = useState([]);

    let isValidDefaultStartDate = true;

    let isValidDefaultEndDate = true;

    const [inValidTruckErrorList, setInValidTruckErrorList] = useState([]);

    const [popperNode, setPopperNode] = useState(null);

    const inValidDateErrorObject = {
        isInvalidEnabledFrom: false,
        isInvalidExpiresOn: false
    };

    const [errorText, setErrorText] = useState({
        truckNumber: '',
        timing: '',
        duplicateTrucks: ''
    });

    useEffect(() => {
        clearTruck();
    }, [clearTruck]);

    const isNoTruckFound = mobilityData.length === 0;

    const getSuggestions = (value) => {
        setErrorText('');

        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;

        let vehicleData = mobilityData.map((truck) => truck.truck_number);
        return inputLength === 0
            ? []
            : vehicleData.filter((suggestion) => {
                  return suggestion.toString().slice(0, inputLength).toLowerCase() === inputValue;
              });
    };

    const sendSelectedTruck = (suggestion) => {
        setShowSearchTruck(false);
        if (allowTruck(suggestion)) {
            let truckEditMap = [...truckInputEditList];
            let index = Object.keys(truckEditMap).length;
            truckEditMap[index] = {};
            truckEditMap[index].enabled_from = false;
            truckEditMap[index].expires_on = false;
            setTruckInputEditList([...truckEditMap]);
            let truckMap = {};
            let agreement = {};
            agreement.truck_number = suggestion;
            agreement.truck_id = mobilityData.filter(
                (truck) => truck.truck_number === suggestion
            )[0].vehicle_id;
            agreement.status = true;
            agreement.enabled_from = startDate;
            agreement.expires_on = endDate;
            agreement.global_enabled_from = startDate;
            agreement.global_expires_on = endDate;
            agreement.agreement_type = Constants.AGREEMENT_TRUCK;
            agreement.group_name = Constants.GPS_ONLY;
            truckMap.truck_id = agreement.truck_id;
            truckMap.truck_number = suggestion;
            truckMap.newTruck = agreement;
            addNewTruck(agreement);
        }
    };

    const toggleTruckSearch = () => {
        if (!isNoTruckFound && isValidDefaultStartDate && isValidDefaultEndDate) {
            setShowSearchTruck(!showSearchTruck);
        }
    };

    const formatDefaultStringDate = (date) => {
        if (date !== null) {
            return format(date, 'MM/dd/yyyy');
        }
        return '';
    };

    const renderInput = (inputProps) => {
        const { InputProps, classes, ref, ...other } = inputProps;

        return (
            <TextField
                onBlur={() => toggleTruckSearch()}
                InputProps={{
                    inputRef: ref,
                    classes: {
                        root: classes.inputRoot,
                        input: classes.inputInput
                    },
                    ...InputProps
                }}
                {...other}
            />
        );
    };

    const handleChange = (item) => {
        sendSelectedTruck(item);
        let tempInvalidErrorList = [...inValidTruckErrorList];
        tempInvalidErrorList.push({ ...inValidDateErrorObject });
        setInValidTruckErrorList([...tempInvalidErrorList]);
    };

    const toggleTruckSearchComponent = () => {
        const renderSuggestion = (
            groupNamesSuggestion,
            index,
            itemProps,
            highlightedIndex,
            selectedItem
        ) => {
            const isHighlighted = highlightedIndex === index;
            const isSelected = (selectedItem || '').indexOf(groupNamesSuggestion) > -1;

            return (
                <MenuItem
                    {...itemProps}
                    key={groupNamesSuggestion}
                    selected={isHighlighted}
                    component="div"
                    style={{
                        fontWeight: isSelected ? 500 : 400,
                        overflowY: 'auto'
                    }}
                >
                    {groupNamesSuggestion}
                </MenuItem>
            );
        };

        renderSuggestion.propTypes = {
            highlightedIndex: PropTypes.number,
            index: PropTypes.number,
            itemProps: PropTypes.object,
            selectedItem: PropTypes.string,
            suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired
        };

        if (showSearchTruck) {
            return (
                <Downshift
                    id="downshift-simple"
                    onChange={handleChange}
                    selectedItem={selectedItem}
                >
                    {({
                        getInputProps,
                        getItemProps,
                        getMenuProps,
                        highlightedIndex,
                        inputValue,
                        selectedItem
                    }) => (
                        <div className={classes.container}>
                            {renderInput({
                                fullWidth: true,
                                classes,
                                InputProps: getInputProps({
                                    autoFocus: true
                                }),
                                ref: (node) => {
                                    setPopperNode(node);
                                }
                            })}
                            <div {...getMenuProps()}>
                                {inputValue.trim() !== '' ? (
                                    <Paper
                                        className={classes.dropDownPaper}
                                        anchorel={popperNode}
                                        square
                                        style={{
                                            position: 'fixed',
                                            minWidth: popperNode
                                                ? popperNode.clientWidth
                                                : undefined,
                                            width: 'max-content',
                                            zIndex: 1500000
                                        }}
                                    >
                                        {getSuggestions(inputValue).map((suggestion, index) =>
                                            renderSuggestion(
                                                suggestion,
                                                index,
                                                getItemProps({ item: suggestion }),
                                                highlightedIndex,
                                                selectedItem
                                            )
                                        )}
                                    </Paper>
                                ) : null}
                            </div>
                        </div>
                    )}
                </Downshift>
            );
        }
        return (
            <div id={'addTruckButton'} onClick={toggleTruckSearch}>
                {!isNoTruckFound ? 'add Truck' : 'No Vehicles'}
            </div>
        );
    };

    const editTruck = (index, agreement, fieldName) => {
        let truckEditMap = [...truckInputEditList];
        truckEditMap[index][fieldName] = !truckEditMap[index][fieldName];
        setTruckInputEditList([...truckEditMap]);
    };

    const toggleDateField = (agreement, fieldName, index) => {
        let agreementField = agreement[fieldName];
        if (truckInputEditList[index] && truckInputEditList[index][fieldName]) {
            return (
                <MuiThemeProvider theme={DEFAULT_THEME}>
                    <DatePicker
                        keyboard
                        id={fieldName}
                        name={fieldName}
                        format={'MM/dd/yyyy'}
                        showTodayButton
                        onError={handleErrorDateChange(index, fieldName)}
                        className={classes.textField}
                        onChange={handleDateChange(index, fieldName, agreement)}
                        onBlur={handleBlankDateInAgreement(index, fieldName, agreement)}
                        value={agreementField}
                        InputLabelProps={{
                            shrink: true
                        }}
                        disableOpenOnEnter
                        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                    />
                </MuiThemeProvider>
            );
        }
        return (
            <div onClick={() => editTruck(index, agreement, fieldName)}>
                {formatDefaultStringDate(agreementField)}
            </div>
        );
    };

    const allowTruck = (suggestion) => {
        return true;
    };

    const handleErrorDateChange = (index, fieldName) => (date) => {
        let tempInvalidErrorList = [...inValidTruckErrorList];
        if (fieldName === 'enabled_from') {
            tempInvalidErrorList[index].isInvalidEnabledFrom = true;
        } else {
            tempInvalidErrorList[index].isInvalidExpiresOn = true;
        }
        setInValidTruckErrorList([...tempInvalidErrorList]);
        validateTruckInfo();
    };

    const handleBlankDateInAgreement = (index, fieldName, agreement) => (event) => {
        if (event.target.value === '') {
            let truckEditMap = [...truckInputEditList];
            truckEditMap[index][fieldName] = false;
            setTruckInputEditList([...truckEditMap]);
        }
        validateTruckInfo();
    };

    const validateTruckInfo = () => {
        setErrorText('');
        let truckList = [];
        if (isNotEmptyList(agreements[Constants.GPS_ONLY])) {
            truckList = agreements[Constants.GPS_ONLY];
        }

        let errorTruckList = [];
        let errorTimingList = [];
        let errorEnteredTruckList = [];

        let errorDateTruckList = [];

        let error = {};
        if (newTruckRequest.length === 0) {
            error.truckNumber = 'Truck Number' + Constants.IS_REQUIRED;
            setErrorText(error);
            return true;
        }
        let allTruckList = [];

        allTruckList = allTruckList.concat(newTruckAgreementList);
        allTruckList = allTruckList.concat(newTruckRequest);

        newTruckRequest.forEach((tr, index) => {
            if (
                inValidTruckErrorList[index].isInvalidEnabledFrom ||
                inValidTruckErrorList[index].isInvalidExpiresOn
            ) {
                errorDateTruckList.push(tr.truck_number);
                return true;
            }
            if (errorDateTruckList.length === 0) {
                if (
                    allTruckList.filter((newTruck) => {
                        if (tr.truck_number === newTruck.truck_number) {
                            return true;
                        }
                        return false;
                    }).length > 1
                ) {
                    if (!errorEnteredTruckList.includes(tr.truck_number)) {
                        errorEnteredTruckList.push(tr.truck_number);
                    }
                }

                if (tr.enabled_from >= tr.expires_on) {
                    errorTimingList.push(tr.truck_number);
                }
                truckList.forEach((truck) => {
                    if (tr.truck_number === truck.truck_number) {
                        errorTruckList.push(tr.truck_number);
                    }
                });
            }
        });

        if (errorDateTruckList.length > 0) {
            error.inValidDates =
                errorDateTruckList.join(', ') + ' - You have entered invalid date(s)';
            setErrorText(error);
            return true;
        } else if (errorEnteredTruckList.length > 0) {
            error.duplicateTrucks =
                errorEnteredTruckList.join(', ') + ' - You have entered same Truck Information';
            setErrorText(error);
            return true;
        } else if (errorTimingList.length > 0 && errorTruckList.length > 0) {
            error.timing =
                errorTimingList.join(', ') +
                ' - Tracking Start is greater than Tracking End Timing';
            error.duplicateTrucks =
                errorTruckList.join(', ') +
                ' - An Agreement with entered Truck Information already exists!';
            setErrorText(error);
            return true;
        } else if (errorTimingList.length > 0) {
            error.duplicateTrucks = '';
            error.timing =
                errorTimingList.join(', ') +
                ' - Tracking Start is greater than Tracking End Timing';
            setErrorText(error);
            return true;
        } else if (errorTruckList.length > 0) {
            error.timing = '';
            error.duplicateTrucks =
                errorTruckList.join(', ') +
                ' - An Agreement with entered Truck Information already exists!';
            setErrorText(error);
            return true;
        } else {
            setErrorText('');
            return false;
        }
    };

    const handleDateChange = (index, fieldName, agreement) => (date) => {
        if (date !== null) {
            setErrorText('');
            let truckList = [...newTruckRequest];
            truckList[index][fieldName] = date;
            updateTruck(truckList);
            editTruck(index, agreement, fieldName);
            let tempInvalidErrorList = [...inValidTruckErrorList];
            if (fieldName === 'enabled_from') {
                tempInvalidErrorList[index].isInvalidEnabledFrom = false;
            } else {
                tempInvalidErrorList[index].isInvalidExpiresOn = false;
            }
            setInValidTruckErrorList([...tempInvalidErrorList]);
            validateTruckInfo();
        }
    };

    const createAgreement = () => {
        const isNotValid = validateTruckInfo();
        if (!isNotValid) {
            let temp = [...newTruckRequest];
            temp.forEach((request) => {
                request.truck_id = mobilityData.filter(
                    (truck) => truck.truck_number === request.truck_number
                )[0].vehicle_id;
                request.enabled_from = getLocalDateString(request.enabled_from);
                request.expires_on = getLocalDateString(request.expires_on);
                request.global_enabled_from = getLocalDateString(request.global_enabled_from);
                request.global_expires_on = getLocalDateString(request.global_expires_on);
            });
            newTruckAgreements(temp);
            closeDialog();
        }
    };

    const closeDialog = () => {
        closeAddTruckModel();
        setErrorText('');
        showAddTruck(false);
        clearTruck();
        setShowSearchTruck(false);
        truckInputEditList.forEach((truckReq) => {
            truckReq.enabled_from = false;
            truckReq.expires_on = false;
        });
    };

    const disableAdd = () => {
        return isEmptyList(newTruckRequest) || isNotBlank(errorText);
    };

    const handleRemoveTruck = (index, agreement) => {
        setErrorText('');
        removeTruck(index);
        let truckEditMap = [...truckInputEditList];
        truckEditMap.splice(index, 1);
        setTruckInputEditList([...truckEditMap]);
    };

    return (
        <div className="full-width">
            <Modal open={showAddTruckModel}>
                <Paper style={modalStyle} className={classes.paper}>
                    <Typography variant="h6" id="modal-title">
                        Add Trucks
                    </Typography>
                    <Paper elevation={0} className={css.truckTableBase}>
                        <div className={cs(css.truckTable)}>
                            <div className={cs(css.tableHeader, 'row no-gutters')}>
                                <div className={cs('col-sm-3')}>Truck ID</div>
                                <div className={cs('col-sm-4')}>Tracking Start</div>
                                <div className={cs('col-sm-4')}>Tracking End</div>
                            </div>

                            <div className={cs('row no-gutters', css.tableBody, css.addTruck)}>
                                <div className={cs('col-sm-3 align-self-center')}>
                                    {toggleTruckSearchComponent()}
                                </div>
                                <div className={cs('col-sm-4 align-self-center')}>
                                    {formatDefaultStringDate(startDate)}
                                </div>
                                <div className={cs('col-sm-4 align-self-center')}>
                                    {formatDefaultStringDate(endDate)}
                                </div>
                            </div>
                            <div className={cs(css.tableBodyBase)}>
                                {newTruckRequest.map((agreement, index) => {
                                    return (
                                        <div
                                            className={cs('row no-gutters', css.tableBody)}
                                            key={index}
                                        >
                                            <div
                                                className={cs('col-sm-3 align-self-center')}
                                                id={'truck_number'}
                                            >
                                                {agreement.truck_number}
                                            </div>
                                            <div
                                                className={cs('col-sm-4 align-self-center')}
                                                id={'enabled_from'}
                                            >
                                                {toggleDateField(agreement, 'enabled_from', index)}
                                            </div>
                                            <div
                                                className={cs('col-sm-4 align-self-center')}
                                                id={'expires_on'}
                                            >
                                                {toggleDateField(agreement, 'expires_on', index)}
                                            </div>
                                            <div className={cs('col-sm-1')}>
                                                <div className="col-sm-1 align-self-center">
                                                    <IconButton
                                                        onClick={() =>
                                                            handleRemoveTruck(index, agreement)
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-trash',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Paper>
                    <div>
                        <FormHelperText style={{ color: 'red' }}>
                            {errorText.truckNumber}
                            <br />
                            {errorText.inValidDates}
                            <br />
                            {errorText.timing}
                            <br />
                            {errorText.duplicateTrucks}
                        </FormHelperText>
                        <div className={cs(css.actionButton, 'row no-gutters justify-content-end')}>
                            <div className={cs('row justify-content-end', css.actionButton)}>
                                <div className="col-sm-auto">
                                    <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                                        <Button id={'cancel'} onClick={() => closeDialog()}>
                                            CANCEL
                                        </Button>
                                    </MuiThemeProvider>
                                    <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                                        <Button
                                            id={'add'}
                                            disabled={disableAdd()}
                                            onClick={() => createAgreement()}
                                        >
                                            ADD
                                        </Button>
                                    </MuiThemeProvider>
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => ({
    newTruckRequest: state.agreement.newTruckRequest,
    newTruckAgreementList: state.agreement.newTruckAgreements,
    mobilityData: state.agreement.mobilityData,
    currentAgreement: state.agreement.currentGroup,
    session: state.session.sessionValue
});

const mapDispatchToProps = (dispatch) => {
    return {
        addNewTruck: (agreements) => dispatch(actions.addNewTruck(agreements)),
        newTruckAgreements: (truckAgreements) => {
            dispatch(actions.newTruckAgreements(truckAgreements));
        },
        removeTruck: (index) => {
            dispatch(actions.removeTruck(index));
        },
        clearTruck: () => {
            dispatch(actions.clearTruck());
        },
        updateTruck: (truckList) => {
            dispatch(actions.updateTruck(truckList));
        },
        showAddTruck: (showPopup) => {
            dispatch(actions.showAddTruck(showPopup));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddTruck));
